module.exports = __webpack_public_path__ + "img/niigata.68e5c3bb.png";